import classNames from 'classnames';
import { observer } from 'mobx-react';

import type { UserSnappyGiftData } from '../../stores/user-snappy-gifts/types';
import { useStores } from '../../stores/useStores';

import classes from './UserSnappyGifts.module.scss';

export const UserSnappyGiftsWidget = observer(({ snappyGiftData }: { snappyGiftData: UserSnappyGiftData }) => {
  const { userSnappyGiftsStore } = useStores();

  return (
    <div className="home-widget">
      <div
        className={classNames('circle-parent', classes.circleParent)}
        onClick={() => userSnappyGiftsStore.openSnappyGiftDialogById(snappyGiftData.id)}
      >
        <img alt="snappy gift" src={snappyGiftData.widgetImageUrl} />
      </div>
    </div>
  );
});
